<template>
  <div>
    <ts-card>
      <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
        <h4 class="ts-text-sm">{{ $t('payrollCycle.pageTitle') }}</h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">
                {{ $t('payrollCycle.cycleYear') }}
              </label>
              <ts-date-picker-input
                v-model="model.cycle_year"
                format="YYYY"
                :class="{ 'is-invalid': errors.has('cycle_year') }"
              />
              <div class="invalid-feedback" v-if="errors.has('cycle_year')">
                {{ errors.first('cycle_year') }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">
                {{ $t('payrollCycle.cycleMonth') }}
              </label>
              <ts-date-picker-input
                v-model="model.cycle_month"
                format="MM"
                :class="{ 'is-invalid': errors.has('cycle_month') }"
              />
              <div class="invalid-feedback" v-if="errors.has('cycle_month')">
                {{ errors.first('cycle_month') }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">
                {{ $t('payrollCycle.cycleStatus') }}
              </label>
              <select
                v-model="model.cycle_status"
                class="form-control"
                :class="{ 'is-invalid': errors.has('cycle_status') }"
              >
                <option value="">{{ $t('select') }}</option>
                <option value="Active">Active</option>
                <option value="Revise">Revise</option>
                <option value="Closed">Closed</option>
              </select>
              <div class="invalid-feedback" v-if="errors.has('cycle_status')">
                {{ errors.first('cycle_status') }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-right">
            <ts-button @click.prevent="$emit('close')" :disabled="saving">
              {{ $t('button.cancel') }}
            </ts-button>
            ​<ts-button
              outline
              color="primary"
              class="ml-2 primary"
              :waiting="savingAddNew"
              @click.prevent="saveAddNew"
              v-if="editData === undefined"
              >{{ $t('button.saveAddNew') }}</ts-button
            >
            ​<ts-button
              class="btn-primary ml-2"
              :waiting="saving"
              @click.prevent="store"
              v-if="editData === undefined"
              >{{ $t('button.save') }}</ts-button
            >
            ​<ts-button class="btn-primary ml-2" :waiting="saving" @click.prevent="update" v-if="editData">{{
              $t('button.update')
            }}</ts-button>
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'form-basic-salary',
  props: ['editData'],
  data() {
    return {
      model: {
        cycle_year: moment().format('YYYY'),
        cycle_month: '',
        cycle_status: ''
      },
      errors: new Errors(),
      saving: false,
      savingAddNew: false
    }
  },
  created() {
    this.setEditData()
  },
  methods: {
    update() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('hr/payrollCycle/update', {
          id: this.editData.payroll_cycle_id,
          data: this.model
        })
        .then(response => {
          this.saving = false
          this.$toasted.success(response.message)
          this.$emit('close')
          this.fetchData()
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    store() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('hr/payrollCycle/store', this.model)
        .then(response => {
          this.saving = false
          this.$toasted.success(response.message)
          this.$emit('close')
          this.fetchData()
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    saveAddNew() {
      this.errors = new Errors()
      this.savingAddNew = true
      this.$store
        .dispatch('hr/payrollCycle/store', this.model)
        .then(response => {
          this.savingAddNew = false
          this.$toasted.success(response.message)
          this.fetchData()
          this.clearInput()
        })
        .catch(error => {
          this.savingAddNew = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    fetchData() {
      this.$store.dispatch('hr/payrollCycle/fetch').catch(error => {
        this.$toasted.error(error.message)
      })
    },
    setEditData() {
      if (!_.isEmpty(this.editData)) {
        this.model = {
          cycle_year: this.editData.cycle_year,
          cycle_month: this.editData.cycle_month,
          cycle_status: this.editData.cycle_status
        }
      }
    },
    clearInput() {
      this.model = {
        cycle_year: moment().format('YYYY'),
        cycle_month: '',
        cycle_status: ''
      }
    }
  }
}
</script>
